var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board item"},[_c('BoardTitle',{staticStyle:{"background":"#182127"},attrs:{"icon":_vm.icon,"title":_vm.title,"hint":_vm.hint,"subWindow":_vm.subWindow},on:{"sub-window":function($event){return _vm.$emit('sub-window', $event)}}}),_c('div',{staticClass:"content",class:{ 'flex-container': _vm.flex }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }